import { Injectable, Injector } from '@angular/core';
import { IAclProgram, RoleTypes } from '@carm/_core';
import {
  GroupTypes,
  ProgramTypes,
} from '@carm/_core/access-control-mgt/models';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  IAllowedPrograms,
  IGetPermissionByRoleTypeResponse,
  IGetStaffMemberPermissionResponse,
  Permission,
  PermissionType,
  RoleTypePermission,
} from '../models';
import { RoleTypePermissionService } from './role-type-permission.service';

@Injectable()
export class RolePermissionLoadingService extends BaseApiService {
  constructor(protected injector: Injector, private roleTypePermissionService: RoleTypePermissionService) {
    super(injector);
  }

  public getPermissionByRoleType(
    roleType: RoleTypes
  ): Observable<RoleTypePermission> {
    const url = `${environment.business.default.baseUrl}/roles/permissions/${roleType}`;
    return this.httpGet<IGetPermissionByRoleTypeResponse>(url).pipe(
      map(data => this.mapPermissionTypes(data, roleType))
    );
  }

  public getPermissions(
    programId: string
  ): Observable<Permission[]> {
    const url = programId
     ? `${environment.business.default.baseUrl}/permission?programId=${programId}`
     : `${environment.business.default.baseUrl}/permission`;
    return this.httpGet<IGetStaffMemberPermissionResponse>(url).pipe(
      map(data => this.mapPermissions(data.permissions)),
      tap(data => this.roleTypePermissionService.updatePermissions(data))
    );
  }

  public getBusinessPermissions(
    businessId: string
  ): Observable<Permission[]> {
    if (!businessId)
    return of([]);
    const url = `${environment.business.default.baseUrl}/permission?businessId=${businessId}`;
    return this.httpGet<IGetStaffMemberPermissionResponse>(url).pipe(
      map(data => this.mapPermissions(data.permissions))
    );
  }

  // public getProgramPermissions(): Observable<IAclProgram[]> {
  //   const url = `${environment.business.default.baseUrl}/roles/permissions/programs`;
  //   return this.httpGet<IGetProgramPermissionsResponse>(url).pipe(
  //     map(data => data.permissions.map(per => this.mapProgramsPermission(per)))
  //   );
  // }

  private mapPermissionTypes(
    res: IGetPermissionByRoleTypeResponse,
    roleType: RoleTypes
  ): RoleTypePermission {
    if (res && res.permissions && res.permissions.length > 0) {
      const outputPermissions: any = [];
      res.permissions.forEach(permission => {
        outputPermissions.push({
          permissionType: permission.role,
          resource: permission.resource,
          group: this.getGroupType(permission.role),
        });
      });
      return { roleType, permissions: outputPermissions };
    }
    return null;
  }

  private mapPermissions(permissions: string[]): Permission[] {
    if (permissions && permissions.length > 0) {
      const outputPermissions: Permission[] = [];
      permissions.forEach(permission => {
        outputPermissions.push(this.parsePermission(permission));
      });
      return outputPermissions;
    }
    return null;
  }

  private parsePermission(permission: string){
    let spl = permission.split('_');
    const roleType = spl[spl.length -1];
    const resource = permission.replace('_'+roleType,'');

   return {
      permissionType: roleType ? roleType as PermissionType
                      : PermissionType.NoAccess,
      resource: resource,
      group: this.getGroupType(roleType),
    }
  }

  private mapProgramsPermission(res: IAllowedPrograms): IAclProgram {
    return {
      resourceName: res.resource,
      allowedPrograms: res.allowedPrograms
        ?.split(',')
        ?.map(program => <ProgramTypes>program),
    };
  }


  getGroupType(inType: string): GroupTypes {
    switch (inType) {
      case 'EDIT':
        return GroupTypes.Editor;
      case 'ADMIN':
        return GroupTypes.Admin;
      case 'MANAGER':
        return GroupTypes.Manager;
      case 'READ':
        return GroupTypes.Reader;
    }
  }
}
